import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked-circle-2--sprite",
  "use": "checked-circle-2--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checked-circle-2--sprite\">\n<path d=\"M7 1.75C4.102 1.75 1.75 4.102 1.75 7C1.75 9.898 4.102 12.25 7 12.25C9.898 12.25 12.25 9.898 12.25 7C12.25 4.102 9.898 1.75 7 1.75ZM5.95 9.625L3.325 7L4.06525 6.25975L5.95 8.13925L9.93475 4.1545L10.675 4.9L5.95 9.625Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol